import { ToroController } from './../../../api/models/toro-controller.model';
import { createAction, props } from '@ngrx/store';
import { ToroControllerBundle } from './../../../api/models/toro-controller-bundle';
import { ToroStation } from './../../../api/models/toro-station.model';
import { ToroLocationDetailed } from './../../../api/models/toro-location-detailed.model';
import { CommCardDetailed } from './../../../api/models/comm-card/comm-card-detailed.model';
import { ToroControllerConfiguration } from './../../../api/models/toro-controller-configuration.model';


export const loadControllersForLocation = createAction(
    '[Controllers] Load Controllers For Location',
    props<{ location: ToroLocationDetailed }>()
);

export const setControllersForLocation = createAction(
    '[Controllers] Set Controllers For Location',
    props<{ controllers: ToroController[] }>()
);

export const setControllersConfiguration = createAction(
    '[Controllers] Set Controller configuration For Location',
    props<{ configurations: Map<number, ToroControllerConfiguration> }>()
);

export const setControllersCommcard = createAction(
    '[Controllers] Set Controller commcards For Location',
    props<{ commcards: Map<number, CommCardDetailed> }>()
);

export const addController = createAction(
    '[Controllers] Add Controller',
    props<{ accountId: number, controller: ToroController }>()
);

export const clear = createAction(
    '[Controllers] Clear all controllers'
);

export const selectController = createAction(
    '[Controllers] Select current Controller',
    props<{ currentController: ToroController }>()
);

export const selectZone = createAction(
    '[Controllers] Select current Zone',
    props<{ currentStation: ToroStation }>()
);

export const controllerActionTypes = {
    loadControllersForLocation,
    addController,
    setControllersForLocation,
    setControllersConfiguration,
    setControllersCommcard,
    clear,
    selectController,
    selectZone
}
